import axiosTuri from "../../axiosTuri";

// Get All Items
export const getAllUsers = async () => {
  const res = await axiosTuri.get(`get-all-users`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store Item API
export const createUser = async (data) => {
  const res = await axiosTuri.post(`add-user`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Update Item API
export const updateItem = async (data) => {
  const res = await axiosTuri.put(`users/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Item API
export const deleteItem = async (id) => {
  const res = await axiosTuri.delete(`users/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};
